import PeopleCustomFields from './PeopleCustomFields';

export default PeopleCustomFields;
